$('.js-readmoreLink').on('click', (e) => {
  const current = $(e.currentTarget)
  const spanText = current.find('span')
  const title = current.data('title')
  const titleSec = current.data('title-sec')
  const text = current.prev()

  text.toggleClass('is_visible_all_text')

  if (text.hasClass('is_visible_all_text')) {
    spanText.text(titleSec)
  } else {
    spanText.text(title)
  }
})
